export default __webpack_public_path__ + "static/media/file_00001 (9).150f5001.pdf";